module.exports = __webpack_public_path__ + "static/media/steamer.02617a3f.png";